module.exports = __webpack_public_path__ + "img/thumb-009-22.df458813.png";